export type fileTypes = "image" | "application" | "text";

export type imageTypes =  "png" | "jpeg" | "jpg" | "gif";
export type applicationTypes = "pdf" | "vnd.openxmlformats-officedocument.spreadsheetml.sheet" | "vnd.ms-excel" | "vnd.openxmlformats-officedocument.presentationml.presentation" | "vnd.ms-powerpoint";
export type textTypes = "csv";

export interface fileExtensions {
    image: imageTypes[] | "*"[],
    application: applicationTypes[],
    text: textTypes[]
}
export interface fileAttributes {
    fileName?: string,
    fileType?: string,
}
export interface genericFileUploadTypes{
    label:string,
    setFile?: React.Dispatch<React.SetStateAction<File | null>>,
    file?: File | null,
    defaultFile?: string,
    setDefaultFile?: React.Dispatch<React.SetStateAction<string>>,
    className?: string,
    resolution?: {
        height: number,
        width: number
    }
    accept: {
        [key in fileTypes]?: fileExtensions[key]
    },
    fetchBlobKey?: boolean,
    fileAttributes?: fileAttributes,
    setFileAttributes?: React.Dispatch<React.SetStateAction<fileAttributes>>,
    errorMessage?: string,
    maxImageSize?: number;
    maxGifSize?: number;
}
export const imageExtensions = ["png","jpeg","svg"];
export const pdfExtensions = ["pdf"];
export const excelExtensions = ["xlsx","csv","xlsm","xltx"];